import configuration from './../config.json'
import CarsService from '../shared/services/carsService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_DELETE_CAR_BOOKMARK = 'REQUEST_DELETE_CAR_BOOKMARK'
const RESPONSE_DELETE_CAR_BOOKMARK = 'RESPONSE_DELETE_CAR_BOOKMARK'
const REQUEST_DELETE_CAR_BOOKMARK_FAILURE = 'REQUEST_DELETE_CAR_BOOKMARK_FAILURE'

const requestDeleteCarBookmarkAction = () => {
  return {
    type: REQUEST_DELETE_CAR_BOOKMARK
  }
}

const responseDeleteCarBookmarkAction = () => {
  return {
    type: RESPONSE_DELETE_CAR_BOOKMARK
  }
}

const requestDeleteCarBookmarkFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_CAR_BOOKMARK_FAILURE,
    errors
  }
}

const deleteCarBookmark = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteCarBookmarkAction())

    CarsService.deleteBookmark(id)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)

        dispatch(responseDeleteCarBookmarkAction())
      })
      .catch((error) => {
        dispatch(requestDeleteCarBookmarkFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  deleteCarBookmark,
  requestDeleteCarBookmarkAction,
  responseDeleteCarBookmarkAction,
  requestDeleteCarBookmarkFailureAction,
  REQUEST_DELETE_CAR_BOOKMARK,
  RESPONSE_DELETE_CAR_BOOKMARK,
  REQUEST_DELETE_CAR_BOOKMARK_FAILURE
}